import { render, staticRenderFns } from "./my-share-item.vue?vue&type=template&id=37b9217d"
import script from "./my-share-item.vue?vue&type=script&lang=ts"
export * from "./my-share-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports